<template>
  <div class="widget-title">
    <h4>
      <slot></slot>
    </h4>
  </div>
</template>

<style scoped>
.widget-title {
  background: #f8f9ff;
  padding: 30px;
}

.widget-title h4 {
  position: relative;
  font-size: 22px;
  font-size: 22px;
  color: #3a4368;
  font-weight: 600;
}

.widget .widget-title h4:after {
  position: absolute;
  content: '';
  width: 55px;
  height: 3px;
  background: #3464e0;
  bottom: -30px;
  left: 0;
}
</style>
